// Grupos de WhatsApp visíveis para todos os atendentes ou para um setor
// (14/10/2026, Rio Brás tkt 60318). Configuração "groupsVisibility":
//   - "admins" (padrão, chave ausente): regra de sempre;
//   - "all": todo atendente vê os grupos, de qualquer dono/setor;
//   - "queue": só quem é do setor "groupsQueueId".
// Mesma regra do backend (helpers/TicketAccess.ts -> gruposVisiveisPara).

const valor = (settings, key) =>
	(Array.isArray(settings) ? settings : []).find((s) => s.key === key)?.value;

// Grupo é "de todos" (all/queue): ninguém vira dono, sem som e sem Finalizar.
export const gruposCompartilhados = (settings) => {
	const modo = valor(settings, "groupsVisibility");
	return modo === "all" || modo === "queue";
};

export const gruposVisiveisPara = (settings, user) => {
	const modo = valor(settings, "groupsVisibility");
	if (modo === "all") return true;
	if (modo !== "queue") return false;
	const setor = Number(valor(settings, "groupsQueueId"));
	return setor > 0 && (user?.queues || []).some((q) => q.id === setor);
};
